import groupBy from './groupBy';

export const utils = {
  groupBy,
};
